<template>
  <div>
    <b-tabs small card fill>
      <b-tab title="Filtering">
        <b-row class="mt-4">
          <b-col cols="6">
            <div style="display:flex;">
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.isIDD"
              >IDD</b-form-checkbox>
              <!-- <b-form-checkbox class="mx-3" v-model="$store.state.priConfigrationforms.sanctions.isIddPlus">IDD Plus</b-form-checkbox> -->
            </div>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Set Match Scores :">
              <v-select
                :disabled="searchPage"
                size="sm"
                :searchable="true"
                :clearable="true"
                label="text"
                v-model="$store.state.priConfigrationforms.sanctions.setMatchScores"
                :options="setMatchScoresOptions"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="6">
            <b-form-group>
              <label>Event Category Code</label>
              <b-form-checkbox-group
                v-model="$store.state.priConfigrationforms.sanctions.eventCategoryCodeSelected"
                v-for="(categoryCode,index) in eventCategoryCodeOptions"
                :key="index"
                style="display:flex;"
              >
                <b-form-checkbox
                  :disabled="searchPage"
                  inline
                  :value="categoryCode.Code"
                >&nbsp; &nbsp; {{'['+categoryCode.Code+'] - '+categoryCode.Description}}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label>Event Sub Category Code</label>
              <b-form-checkbox-group
                v-model="$store.state.priConfigrationforms.sanctions.eventSubCategoryCodeSelected"
                v-for="(subCategoryCode,index) in eventSubCategoryCodeOptions"
                :key="index"
                style="display:flex;"
              >
                <b-form-checkbox
                  :disabled="searchPage"
                  inline
                  :value="subCategoryCode.Code"
                >&nbsp; &nbsp; {{'['+subCategoryCode.Code+'] - '+subCategoryCode.Description}}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Scoring">
        <div>
          <b-form-group>
            <div style="display:flex;">
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.CVIP"
              >CVIP&nbsp; &nbsp;</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.riskScore"
              >Risk Score&nbsp; &nbsp;</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.textMatch"
              >Text Match&nbsp; &nbsp;</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.pepMatch"
              >PEP Match&nbsp; &nbsp;</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.entityMatch"
              >Entity Match&nbsp; &nbsp;</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.sanctions.identifierMatch"
              >Identifier Match&nbsp; &nbsp;</b-form-checkbox>
            </div>
          </b-form-group>
        </div>
        <b-tabs class="mb-4" small card fill>
          <b-tab title="Match Rating">
            <b-table-simple class="table my-2">
              <b-thead>
                <b-tr>
                  <b-th scope="col">Risk</b-th>
                  <b-th scope="col">From</b-th>
                  <b-th scope="col">To</b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <b-tr>
                  <b-td>
                    <b-badge variant="success">Negative</b-badge>
                  </b-td>
                  <b-td>1</b-td>
                  <b-td>
                    <b-form-input
                      :disabled="searchPage"
                      v-model="$store.state.priConfigrationforms.sanctions.lowerUpperLimit"
                      onkeydown="return event.keyCode !== 69"
                      type="number"
                      max="30"
                    ></b-form-input>
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-td>
                    <b-badge variant="warning">Refer</b-badge>
                  </b-td>
                  <b-td>{{$store.state.priConfigrationforms.sanctions.lowerUpperLimit ? parseInt($store.state.priConfigrationforms.sanctions.lowerUpperLimit)+1 : 0}}</b-td>
                  <b-td>
                    <b-form-input
                      :disabled="searchPage"
                      onkeydown="return event.keyCode !== 69"
                      v-model="$store.state.priConfigrationforms.sanctions.mediumUpperLimit"
                      type="number"
                      min="31"
                      max="75"
                    ></b-form-input>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>
                    <b-badge variant="danger">Match</b-badge>
                  </b-td>
                  <b-td>{{$store.state.priConfigrationforms.sanctions.mediumUpperLimit ? parseInt($store.state.priConfigrationforms.sanctions.mediumUpperLimit)+1 : 0}}</b-td>
                  <b-td>100</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-tab>
          <b-tab title="CVIP" v-if="$store.state.priConfigrationforms.sanctions.CVIP">
            <AddRowComponent />
          </b-tab>
          <b-tab title="Risk Score" v-if="$store.state.priConfigrationforms.sanctions.riskScore">
            <AddRowComponentWithRangeRiskScore />
          </b-tab>
          <b-tab title="Text Match" v-if="$store.state.priConfigrationforms.sanctions.textMatch">
            <b-tabs>
              <b-tab title="Process score">
                <AddRowComponentWithRangeProcessScore />
              </b-tab>
              <b-tab title="Similar text">
                <AddRowComponentWithRangeSimilarText />
              </b-tab>
              <b-tab title="Token Ratio">
                <AddRowComponentWithRangeTokenRatio />
              </b-tab>
              <b-tab title="Token Sort Ratio">
                <AddRowComponentWithRangeTokenSortRatio />
              </b-tab>
              <b-tab title="Soundex">
                <b-form-group label="Score">
                  <b-form-input
                    v-model="$store.state.priConfigrationforms.sanctions.soundEx"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab title="PEP Match" v-if="$store.state.priConfigrationforms.sanctions.pepMatch">
            <b-form-group label="Score">
              <b-form-input
                v-model="$store.state.priConfigrationforms.sanctions.pepMatchInput"
                type="text"
              ></b-form-input>
            </b-form-group>
          </b-tab>
          <b-tab
            title="Entity Match"
            v-if="$store.state.priConfigrationforms.sanctions.entityMatch"
          >
            <b-form-group label="Score">
              <b-form-input
                v-model="$store.state.priConfigrationforms.sanctions.entityMatchScore"
                type="text"
              ></b-form-input>
            </b-form-group>
          </b-tab>
          <b-tab
            title="Identifier Match"
            v-if="$store.state.priConfigrationforms.sanctions.identifierMatch"
          >
            <b-table-simple class="table my-2">
              <b-thead>
                <b-th>Title</b-th>
                <b-th>Score</b-th>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="(identifiersData, index) in $store.state.priConfigrationforms.sanctions.identifiersItems"
                  :key="index"
                >
                  <b-td>{{identifiersData.title}}</b-td>
                  <b-td>
                    <b-form-group>
                      <b-form-input v-model="identifiersData.score" type="text" size="sm"></b-form-input>
                    </b-form-group>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-tab>
        </b-tabs>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import AddRowComponent from "./addRowComponent/addRowComponent.vue";
import AddRowComponentWithRangeRiskScore from "./addRowComponent/addRowComponentWithRangeRiskScore.vue";
import AddRowComponentWithRangeProcessScore from "./addRowComponent/addRowComponentWithRangeProcessScore.vue";
import AddRowComponentWithRangeSimilarText from "./addRowComponent/addRowComponentWithRangeSimilarText.vue";
import AddRowComponentWithRangeTokenRatio from "./addRowComponent/addRowComponentWithRangeTokenRatio.vue";
import AddRowComponentWithRangeTokenSortRatio from "./addRowComponent/addRowComponentWithRangeTokenSortRatio.vue";
import EventCategoryCodeData from "../../../utils/remediationJson/eventCategoryCode.json";
import EventSubCategoryCodeData from "../../../utils/remediationJson/eventSubCategoryCode.json";
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "SanctionsEnforcementsComponent",
  components: {
    AddRowComponent,
    AddRowComponentWithRangeRiskScore,
    AddRowComponentWithRangeProcessScore,
    AddRowComponentWithRangeSimilarText,
    AddRowComponentWithRangeTokenRatio,
    AddRowComponentWithRangeTokenSortRatio
  },
  data() {
    return {
      eventCategoryCodeOptions: EventCategoryCodeData.EventCategoryCode,
      eventSubCategoryCodeOptions:
        EventSubCategoryCodeData.EventSubCategoryCode,
      setMatchScoresOptions: [
        { text: 50, value: 50 },
        { text: 55, value: 55 },
        { text: 60, value: 60 },
        { text: 65, value: 65 },
        { text: 70, value: 70 },
        { text: 75, value: 75 },
        { text: 80, value: 80 },
        { text: 85, value: 85 },
        { text: 90, value: 90 },
        { text: 95, value: 95 },
        { text: 100, value: 100 }
      ]
    };
  },
  mounted() {
    if (
      this.$store.state.priConfigrationforms.sanctions.identifiersItems
        .length == 0
    ) {
      this.getIdentifiersTableData();
    }
  },
  methods: {
    async getIdentifiersTableData() {
      this.tableItems = [];
      let formData = {
        company_id: this.$route.params.id
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/get-identifiers-list", formData, {
        Authorization: token
      });
      return result
        .then(response => {
          response.data.map(identifiersData => {
            if (identifiersData.identifiers) {
              let identifiersValue = JSON.parse(identifiersData.identifiers);
              this.$store.state.priConfigrationforms.sanctions.identifiersItems = identifiersValue;
            }
            this.isLoading = false;
          });
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    }
  },
  props: {
    searchPage: Boolean
  }
};
</script>